import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Menu as menu } from 'antd';

const { ItemGroup, Item } = menu;

const StyledMenu = styled(menu)`
  .ant-menu-item-selected {
    background: none !important;
  }

  .ant-menu-item-group-title {
    color: #0c2340;
    font-weight: bold;
  }

  .ant-menu-item {
    padding-left: 8px !important;
    margin-left: 8px;
    border-bottom: 1px solid #ebebeb;
  }

  .ant-menu {
    background: none !important;
    border-right: none !important;
  }
`;

const VerticalMenu = ({ menuItems, notifications, defaultKey }) => {
  const defaultScroll = notifications && 'notifications';
  const [scrollTo, setScrollTo] = useState(defaultScroll);
  const [current, setCurrent] = useState(defaultKey);
  const [activeKey, setActiveKey] = useState(menuItems[0].key);
  const toElement = document.getElementById(scrollTo);
  useEffect(() => {
    toElement && toElement.scrollIntoView({ behavior: 'smooth' });
  }, [menuItems, scrollTo, toElement]);

  return (
    <StyledMenu mode='inline' selectedKeys={[current]} style={{ background: 'none', borderRight: 'none' }}>
      {menuItems.map(menuItem => (
        <ItemGroup key={menuItem.key} title={<span style={activeKey === menuItem.key ? { color: '#137AC9' } : {}}>{menuItem.title}</span>}>
          {menuItem.items.map(item => (
            <Item
              key={item.key}
              onClick={() => {
                setScrollTo(item.dataTestId);
                item.onClick();
                setCurrent(item.key);
                setActiveKey(menuItem.key);
              }}
              data-testid={item.dataTestId}
            >
              {item.name}
            </Item>
          ))}
        </ItemGroup>
      ))}
    </StyledMenu>
  );
};

/** @component */
export default VerticalMenu;
